import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils.ts';

/**
 * Tabla densa 13px con cabecera sticky (skill diseno-visual-mg). Altura tope del 70 % de la pantalla con su propio
 * desplazamiento: la barra horizontal de una tabla ancha (libros) queda a la vista y no al final de cientos de filas
 * (pedido del usuario del 2026-10-30). Al imprimir sale completa.
 */
export function Table({ className, ...props }: ComponentProps<'table'>) {
  return (
    <div className="relative max-h-[70vh] w-full overflow-auto rounded-xl border bg-card print:max-h-none print:overflow-visible" data-tabla-desplazable="">
      <table className={cn('w-full caption-bottom text-[13px]', className)} {...props} />
    </div>
  );
}
export function TableHeader({ className, ...props }: ComponentProps<'thead'>) {
  return <thead className={cn('sticky top-0 z-10 bg-muted/80 backdrop-blur [&_tr]:border-b', className)} {...props} />;
}
export function TableBody({ className, ...props }: ComponentProps<'tbody'>) {
  return <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props} />;
}
export function TableRow({ className, ...props }: ComponentProps<'tr'>) {
  return <tr className={cn('border-b transition-colors hover:bg-accent/40 data-[state=selected]:bg-accent', className)} {...props} />;
}
export function TableHead({ className, ...props }: ComponentProps<'th'>) {
  return <th className={cn('h-9 px-3 text-left align-middle text-xs font-semibold uppercase tracking-wide text-muted-foreground', className)} {...props} />;
}
export function TableCell({ className, ...props }: ComponentProps<'td'>) {
  return <td className={cn('px-3 py-2 align-middle', className)} {...props} />;
}
